import Div100vh from 'react-div-100vh';

import styled, { css } from 'styled-components';

export const WrapperPreLogin = styled(Div100vh)`
  display: flex;
  flex-direction: column;
`;

export const Wrapper = styled.div`
  ${({ theme: { breakpoints, colors } }) => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: ${colors.grey7};

    @media (max-width: ${breakpoints.sm}) {
      background-color: ${colors.white};
    }
  `}
`;

export const HeroDesktop = styled.div`
  ${({ theme: { breakpoints } }) => css`
    @media (max-width: ${breakpoints.sm}) {
      display: none;
    }
  `}
`;

export const HeroMobile = styled.div`
  ${({ theme: { breakpoints } }) => css`
    @media (min-width: calc(${breakpoints.sm} + 1px)) {
      display: none;
    }
  `}
`;
